<template>
  <div class="">
    <section class="flex items-center justify-center p-6">
      <div class="">
        <div class="flex items-center justify-center">
          <img class="w-16 h-16" alt="Vue logo" src="../assets/laravelui-logo.png">
          <span class="text-3xl font-bold text-white pl-2">LaravelUI</span>
        </div>
        <h2 class="text-6xl font-bold text-center text-gray-300">Desing for Developers.</h2>
        <h3 class="text-2xl text-gray-300 text-center">coming soon...</h3>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
